<template>
    <div class="location_payment">
        <div class="form-group mt-2">
            <label class="form-label" for="payment_online">
                {{__t("PAY_TYPE_ONLINE")}}
            </label>

            <div class="" v-if="payments.length > 0">
                <v-select v-model="location.payment_id"
                          id="payment_online"
                          class="imc_reasons"
                          :reduce="payment => payment.id"
                          label="title"
                          :options="this.payments"
                          :filterable="false"
                >
                    <template slot="no-options">
                        Оберіть оплату
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                            <div>
                                <small>
                                    {{option.uniq_id}}
                                </small>
                            </div>
                        </div>

                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="payment_cache">
                {{__t("PAY_TYPE_CACHE")}}
            </label>
            <div class="" v-if="payments.length > 0">
                <v-select v-model="location.pay_cache"
                          class="imc_reasons"
                          id="payment_cache"
                          label="title"
                          :reduce="payment => payment.id"
                          :options="this.payments"
                          :filterable="false"
                >
                    <template slot="no-options">
                        Оберіть оплату
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                            <div>
                                <small>
                                    {{option.uniq_id}}
                                </small>
                            </div>
                        </div>

                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group mt-2" v-if="show_bonus">
            <label class="form-label" for="payment_cache">
                {{__t("PAY_BONUS")}}
            </label>
            <div class="" v-if="payments.length > 0">
                <v-select v-model="location.general_fields.bonus_payment"
                          class="imc_reasons"
                          id="payment_cache"
                          label="title"
                          :reduce="payment => payment.id"
                          :options="this.payments"
                          :filterable="false"
                >
                    <template slot="no-options">
                        Оберіть оплату
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                            <div>
                                <small>
                                    {{option.uniq_id}}
                                </small>
                            </div>
                        </div>

                    </template>
                </v-select>
            </div>
        </div>


    </div>

</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
export default {
    name: "location_payment",
    components : {
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            payments    : [],
        }
    },

    mounted() {
        this.load_payments();
    },

    methods : {
        async load_payments() {
            this.payments = [];
            await api.get('/internal/v1/catalog/organizations/'+ parseInt(this.location.parent_id) +'/payments',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.payments = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed: {
        show_bonus() {
            if(this.location.hasOwnProperty("general_fields")) {
                if(this.location.general_fields.hasOwnProperty('bonus_payment')) {
                    return true;
                }
            }


            return false;
        }
    },

}
</script>


<style scoped>

</style>
